// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5eb0e762","885":"05172ca3"}[chunkId] + ".chunk.js";
};